module.exports = __webpack_public_path__ + "img/gm.7b7d2e77.svg";